<template>
  <Design class="h-100" :customFonts="customFonts">
    <div :class="settingScreenSize.device">
      <div
        id="displayDevice"
        :ref="`displayDevice`"
        :class="`h-100 ${settingScreenSize.deviceDisplay}`"
      >
        <Skeleton :screenSize="screenSize" v-if="loading">
          <SkeletonMobile v-if="screenSize === 'Mobile'" />
          <SkeletonTablet v-else-if="screenSize === 'Tablet'" />
          <SkeletonDesktop v-else />
        </Skeleton>
        <iframe
          v-show="!loading"
          :class="`viewport${screenSize}`"
          @load="loaded"
          id="viewport"
          :ref="`viewport`"
          height="100%"
          :src="buildDate ? `design-iframe?v=${Date.parse(buildDate)}#preview=true` : 'design-iframe#preview=true'"
        >
        </iframe>
      </div>
      <div :class="settingScreenSize.device1"></div>
      <div :class="settingScreenSize.device2"></div>
      <div :class="settingScreenSize.device3"></div>
      <div :class="settingScreenSize.device4"></div>
    </div>
    <ModalPublish/>
  </Design>
</template>

<script>
import { mapGetters } from "vuex";
import { Design, Skeleton } from "./Design.styled";
import SkeletonDesktop from "@components_system/Design/Skeleton/SkeletonDesktop";
import SkeletonTablet from "@components_system/Design/Skeleton/SkeletonTablet";
import SkeletonMobile from "@components_system/Design/Skeleton/SkeletonMobile";
import ModalPublish from "@components_system/Design/Modal/Publish/Publish";

export default {
  components: {
    Design,
    Skeleton,
    SkeletonDesktop,
    SkeletonTablet,
    SkeletonMobile,
    ModalPublish,
  },
  data() {
    return {
      loading: true,
      iframeWin: undefined,
    };
  },

  mounted() {
    let iframeWin = document.getElementById("viewport").contentWindow;
    this.iframeWin = iframeWin;
    this.$store.dispatch("design/page/initialiseDesignIFrame", { iframeWin });
  },

  methods: {
    // disableNestableEvent(count = 0) {
    //   if (count < 10) {
    //     const elementList =
    //       this.iframeWin.document.querySelectorAll('[draggable="true"]');
    //
    //     if (elementList.length > 0) {
    //
    //     } else {
    //       setTimeout(() => this.disableNestableEvent(count++), 200);
    //     }
    //   }
    // },
    loaded() {
      this.loading = false;

      // this.disableNestableEvent();
    },
  },
  computed: {
    ...mapGetters({
      screenSize: "screenSize",
      sections: "design/page/sections",
      customFonts: "design/site/customFonts",
    }),
    settingScreenSize() {
      switch (this.screenSize) {
        case "Mobile":
          return {
            device: "device device-iphone-x",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-btns",
            device3: "device-power",
            device4: "device-home",
          };
        case "Tablet":
          return {
            device: "device device-ipad-pro device-spacegray",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-header",
            device3: "device-sensors",
            device4: "device-btns",
          };

        default:
          return {
            device: "h-100",
            deviceDisplay: "device-frame drop-shadow",
          };
      }
    },
    buildDate() {
      return process.env.VUE_APP_BUILDDATE;
    },
  },
};
</script>

<style>
</style>